import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  ChangeDetectorRef, OnDestroy,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CellPhoneConstants, TextKeyConstants } from 'src/app/models/Constants';
import { GeneralService } from 'src/app/services/general.service';
import { InformationDto } from '../../portal-settings/models/InformationDtos';

@Component({
  selector: 'fi-cell-preference',
  templateUrl: './fi-cell-preference.component.html',
  styleUrls: ['./fi-cell-preference.component.scss'],
})
export class FiCellPreferenceComponent implements OnInit, OnChanges, OnDestroy {
  fiCellPreferenceForm: FormGroup;
  @Output() fiCellPreferenceChange = new EventEmitter<any>();
  @Input() headerName = 'FI';
  @Input() isDisabled: boolean = false;
  @Input() fiCellPreference: boolean = false;
  subscriptions: Subscription = new Subscription();
  preferenceMessage: string = '';
  @Input() persona = '';
  constructor(
    private fb: FormBuilder,
    private generalService: GeneralService,
    private cdr: ChangeDetectorRef,
  ) {
    this.fiCellPreferenceForm = this.fb.group({
      allowCellPhoneDetails: [
        { value: this.fiCellPreference, disabled: this.isDisabled },
        Validators.required,
      ],
    });
    this.subscriptions.add(this.getPageInformation());
  }

  ngOnInit(): void {
    this.fiCellPreferenceForm.controls[
      'allowCellPhoneDetails'
    ].valueChanges.subscribe((value) => {
      this.fiCellPreferenceChange.emit(value);
    });
  }

  getPageInformation() {
    this.generalService
      .GetInformationByName([
        CellPhoneConstants.ODFIPreferenceContent,
        CellPhoneConstants.RDFIPreferenceContent,
        CellPhoneConstants.AchOperatorPreferenceContent,
        CellPhoneConstants.PAPreferenceContent,
      ])
      .then((response: InformationDto[]) => {
        if (response && response.length > 0) {
          const preferenceContentMap: { [key: string]: string } = {
            ODFI: CellPhoneConstants.ODFIPreferenceContent,
            RDFI: CellPhoneConstants.RDFIPreferenceContent,
            ACH_OPERATOR: CellPhoneConstants.AchOperatorPreferenceContent,
            PA: CellPhoneConstants.PAPreferenceContent,
          };

          const contentKey = preferenceContentMap[this.persona];
          if (contentKey) {
            this.preferenceMessage =
              this.generalService.getInformationContentDecoder(
                response,
                contentKey,
              );
          }
          this.cdr.detectChanges();
        }
      });
  }

  ngOnChanges() {
    if (this.fiCellPreferenceForm) {
      this.fiCellPreferenceForm.controls['allowCellPhoneDetails'].setValue(
        this.fiCellPreference,
      );
    }
    if (this.isDisabled) {
      this.fiCellPreferenceForm.controls['allowCellPhoneDetails'].disable();
    } else {
      this.fiCellPreferenceForm.controls['allowCellPhoneDetails'].enable();
    }
    this.getPageInformation();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
